export const ADD_SURVEY_MIDDLE = "ADD_SURVEY_MIDDLE"
export const EDIT_SURVEY_MIDDLE= "EDIT_SURVEY_MIDDLE"
export const LIST_SURVEY_MIDDLE = "LIST_SURVEY_MIDDLE"
export const VIEW_SURVEY_MIDDLE = "VIEW_SURVEY_MIDDLE"
export const DELETE_SURVEY_MIDDLE = "DELETE_SURVEY_MIDDLE"

export const SURVEY_MIDDLE_SUCCESS = "SURVEY_MIDDLE_SUCCESS"
export const SURVEY_MIDDLE_ERROR = "SURVEY_MIDDLE_ERROR"
